import PageContext from "../components/store/page/page-context";
import { useContext, useEffect } from "react";
import defaultlogo from "../assets/images/logo/tsmc-GIW.png";

const usePage = ({ title = "", headerShow = true, logo = defaultlogo }) => {
  const { setData } = useContext(PageContext);

  useEffect(() => {
    setData({ title, headerShow, logo });
  }, [setData, title, headerShow, logo]);
};

export default usePage;
